export default {
  isMozilla(state) {
    return state.browser === "Mozilla";
  },
  isSafari(state) {
    return state.browser === "Safari";
  },
};
